import { Link } from 'react-router';
import { PublicLayout } from '@/app/layouts/PublicLayout';

export function ForbiddenRoute() {
  return (
    <PublicLayout>
      <div className="mx-auto flex min-h-screen max-w-md items-center px-4">
        <div className="w-full rounded-lg border border-stone-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl font-bold text-stone-900" style={{ fontFamily: 'Georgia, serif' }}>Access denied</h1>
          <p className="mt-2 text-sm text-stone-500">You do not have permission to view this page.</p>
          <Link to="/dashboard" className="mt-4 inline-block text-sm font-medium text-amber-800 hover:text-amber-900">
            Return to dashboard
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
